import { render, staticRenderFns } from "./Ecg.vue?vue&type=template&id=155d39cc"
import script from "./Ecg.vue?vue&type=script&lang=js"
export * from "./Ecg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports